module.exports = __webpack_public_path__ + "img/left-box-pt.7ee44729.png";